import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from '../../../components/Link/Link';
import { SEO } from '../../../constants/seo';
import styles from './BreadcrumbsItem.module.css';

const BreadcrumbsItem = ({
  to,
  isActive,
  children,
  className,
  position,
  title,
  isExternal,
}) => {
  return (
    <li
      itemType={SEO.TYPES.LIST_ITEM}
      itemProp={SEO.PROPS.LIST_ELEMENT}
      itemScope
      className={styles.item}
    >
      {isActive ? (
        <>
          <span
            itemProp={SEO.PROPS.NAME}
            className={classNames(styles.active, className)}
          >
            {children}
          </span>
          <meta itemProp={SEO.PROPS.POSITION} content={position} />
        </>
      ) : (
        <Link
          external={isExternal}
          to={to}
          itemProp={SEO.PROPS.ITEM}
          className={classNames(styles.component, className)}
          title={title}
        >
          <span itemProp={SEO.PROPS.NAME}>{children}</span>
          <meta itemProp={SEO.PROPS.POSITION} content={position} />
        </Link>
      )}
    </li>
  );
};

BreadcrumbsItem.propTypes = {
  to: PropTypes.string,
  isActive: PropTypes.bool,
};

BreadcrumbsItem.defaultProps = {
  isActive: false,
};

export default BreadcrumbsItem;
